import React from "react";
import { useSelector } from "react-redux";
import AreaChart from "../../../components/charts/areaChart/areaChart";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { PeriodType } from "./periodType";

export const detectInterval = (data) => {
  let interval = "preserveEnd";

  data.map((item) => {
    if (item.name.indexOf(" - ") > -1) {
      interval = "preserveStartEnd";
    } else {
      interval = Math.floor(data.length * 0.08);
    }
  });

  return interval;
};

export const YearOverYear = () => {
  const chartData = useSelector((state) => state.utilization.graphData.chart_values);
  const decimal = useSelector((state) => state.utilization.graphData.decimal);
  const interval = detectInterval(chartData);
  const currencySymbol = useSelector((state) => state.utilization.chartCurrencySymbol);
  const currentSelectedCategory = useSelector((state) => state.utilization.currentSelectedCategory);
  const toolTipContent = useSelector((state) => state.utilization.averageTooltip);
  const yearOverYearLoading = useSelector((state) => state.utilization.yearOverYearLoading);

  return (
    <>
      <div className="chart-header">
        <h2>Total {currentSelectedCategory} Breakdown</h2>
        <div className="select-box" style={{ width: "200px" }}>
          {yearOverYearLoading ? <LoadingAnimation uiLoader /> : <PeriodType />}
        </div>
      </div>
      <AreaChart
        chartData={chartData}
        interval={interval}
        right={80}
        left={80}
        width={1350}
        currencySymbol={currencySymbol}
        hasRawData
        decimal={decimal}
        hideLegend
        tooltipName={currentSelectedCategory}
        toolTipContent={!!toolTipContent}
      />
    </>
  );
};
